import { createApp } from "vue";
import ImageSlider from "../components/ImageSlider.vue";
import { handleNav } from "./functions/handleNav.es6";
import { ScrollHndler } from "./classes/scrollfunc.es6";
import { modal } from "./functions/modal.es6";

export default class Main {
    constructor() {
        this.init();
    }

    async init() {
        this.ready();

        let banner = await fetch(`${window.location.origin}/wp-json/options/content`);
        banner = (await banner.json()) || [];
        banner = banner.filter((item) => item.banner_image && item.link);
        createApp(ImageSlider, { length: banner.length, items: banner, classNames: ["nav-bnr__items"] }).mount("#nav-bnr");

        handleNav();
        new ScrollHndler();
        modal();
    }

    ready() {
        window.addEventListener("load", () => {
            document.body.classList.add("-load");
        });
    }
}
